import {css} from 'emotion';

const toggle = css`
  white-space: nowrap;
`;

export default {
  toggle,
};
